// ExpressionEditor.tsx
import React from "react";
import Select from "react-select";
import { ExpressionNode, Operator } from "./types";
import './style.scss';

interface Props {
  node: ExpressionNode;
  onChange: (node: ExpressionNode) => void;
  selections: any;
}

const findLabel = (value: any, selections: any) => {
  let found = value;
  selections.forEach((v :any) => {
    if(v["value"] === value){
      found = v["label"];
    }
  });

  return found;
}

const ExpressionVariables: React.FC<any> = ({ value="", onChange, selections }) => {
    const [ selectedValue, setValue ] = React.useState({ label: findLabel(value, selections), value: value });

    return 	<Select
        name="location"
        className="variable-select"
        options={selections}
        value={selectedValue}
        onChange={(selectedOption: any) => {
            setValue(selectedOption);
            onChange({ type: "variable", name: selectedOption.value })
        }}
        //isLoading={isFetching}
        //isDisabled={isFetching || isError}
        // Fixes the z-index issues
        menuPortalTarget={document.body}
        menuPosition='fixed'
    />
}

const ExpressionEditor: React.FC<Props> = ({ node, onChange, selections }) => {
  const handleChangeType = (type: "constant" | "variable" | "operation") => {
    switch (type) {
      case "constant":
        onChange({ type: "constant", value: 0 });
        break;
      case "variable":
        onChange({ type: "variable", name: "" });
        break;
      case "operation":
        onChange({
          type: "operation",
          operator: "+",
          left: { type: "constant", value: 0 },
          right: { type: "constant", value: 0 },
        });
        break;
    }
  };

  if (node.type === "constant") {
    return (
      <div>
        Constant:{" "}
        <input
          type="number"
          value={node.value}
          onChange={(e) =>
            onChange({ ...node, value: parseFloat(e.target.value) })
          }
        />
        <button onClick={() => handleChangeType("variable")}>
          Change to Variable
        </button>
        <button onClick={() => handleChangeType("operation")}>
          Change to Operation
        </button>
      </div>
    );
  }

  if (node.type === "variable") {
    return (
      <div>
        Variable:{" "}
        <ExpressionVariables value={node.name} onChange={onChange} selections={selections}/>
        <button onClick={() => handleChangeType("constant")}>
          Change to Constant
        </button>
        <button onClick={() => handleChangeType("operation")}>
          Change to Operation
        </button>
      </div>
    );
  }

  if (node.type === "operation") {
    return (
      <div style={{ padding: "10px", margin: "5px" }} className="expression-editor">
        <div className="expression-control">
          Operation:{" "}
          <select
            value={node.operator}
            onChange={(e) =>
              onChange({ ...node, operator: e.target.value as Operator })
            }
          >
            <option value="+">+</option>
            <option value="-">-</option>
            <option value="*">*</option>
            <option value="/">/</option>
          </select>
          <button onClick={() => handleChangeType("constant")}>
            Change to Constant
          </button>
          <button onClick={() => handleChangeType("variable")}>
            Change to Variable
          </button>
        </div>
        <div  className="nested">
          Left:
          <ExpressionEditor
            node={node.left}
            onChange={(left) => onChange({ ...node, left })}
            selections={selections}
          />
        </div>
        <div className="nested">
          Right:
          <ExpressionEditor
            node={node.right}
            onChange={(right) => onChange({ ...node, right })}
            selections={selections}
          />
        </div>
      </div>
    );
  }

  return null;
};

export default ExpressionEditor;
